<template>
    <Row type="none" class="bg-white rounded shadow">

        <Modal
            :text="modalText"
            id="modal_show"
        />

        <FormTag v-if="!isEmailSent" class="pt-4">
                <InputBox
                    class="text-gray-500 font-bold text-center"
                    model-name="email"
                    title="user.emailForResetPassword"
                    type="email"
                    :model-form="modelForm"
                    :errors="errors"
                    :model-state="modelEmailState"
                />

            <RowColumn class="container pt-3 text-gray-500" v-if="$i18n.locale === 'uz'">
                Agar akkauntingiz bo'lmasa,
                <router-link class="font-bold" :to="$i18nHelper.getUrl('company/add')">ro'yhatdan o'ting</router-link>
            </RowColumn>
            <RowColumn class="container pt-3 text-gray-500" v-else-if="$i18n.locale === 'ru'">
                Если у вас нет аккаунта,
                <router-link class="font-bold" :to="$i18nHelper.getUrl('company/add')">пройдите регистрацию</router-link>
            </RowColumn>
            <RowColumn class="container pt-3 text-gray-500" v-else>
                Here you can
                <router-link class="font-bold" :to="$i18nHelper.getUrl('company/add')">create account</router-link>
            </RowColumn>
            <MarginTop/>

            <SubmitRow class="pb-4 pl-3" :is-loading="isLoading" :is-disabled="hasErrors" :do-action="reset" text="user.send"/>
        </FormTag>
        <div class="container pb-4" v-if="isEmailSent">
            <p class="text-gray-500 font-bold">
                {{ $t('user.emailSent') }}
                <router-link :to="$i18nHelper.getUrl('forgot-password')">{{ $t('user.tryAgain') }}</router-link>
            </p>
        </div>
    </Row>
</template>

<script>
import loginMixin from "../mixin/loginMixin";
import FormTag from "../components/html/FormTag";
import Row from "../components/html/Row";
import InputBox from "../components/InputBox";
import validatorMixin from "../mixin/validatorMixin";
import SubmitRow from "../components/SubmitRow";
import RowColumn from "../components/RowColumn";
import MarginTop from "../components/html/MarginTop";
import Modal from "@/components/html/Modal";
import {mapActions} from "vuex";

export default {
    components: {Modal, MarginTop, RowColumn, SubmitRow, InputBox, Row, FormTag},
    mixins: [loginMixin, validatorMixin],
    data() {
        return {
            errors: {
                email: null
            },
            modelForm: {
                email: ''
            },
            breadcrumbItems: [
                {name: 'home', url: ''},
                {name: 'user.resetPassword'},
            ],
            isLoading: false,
            isEmailSent: false,
        }
    },
    methods: {
        ...mapActions(['fetchRequestResetPassword', 'setBreadcrumbItems']),
        reset() {
            this.isLoading = true;
            this.fetchRequestResetPassword({email: this.modelForm.email})
                .then(() => {
                    this.isLoading = false;
                    this.isEmailSent = true;
                    })
                .catch((reason) => {
                    if (reason === 'connectionRefused') {
                        this.modalText = this.$t('connectionRefused')
                        this.$bvModal.show('modal_show')
                    } else {
                        this.modalText = this.$t('login.error');
                        this.$bvModal.show('modal_show')
                    }

                    this.isLoading = false;
                })
        }
    },
    mounted() {
        setTimeout(() => this.$root.showOverlay = false, 1000)
    }
}
</script>

<style scoped>

</style>
